<mat-form-field>
  <mat-label>{{ 'core.constructionSite' | translate }}</mat-label>
  <input
    type="text"
    placeholder="{{ 'constructionSite.search.placeholder' | translate }}"
    matInput
    [formControl]="control"
    [matAutocomplete]="auto"
    #trigger="matAutocompleteTrigger"
    (focus)="onFocus()"
    >
  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayConstructionSite">
    @for (constructionSite of filteredConstructionSites$ | async; track constructionSite) {
      <mat-option [value]="constructionSite">
        {{ constructionSite.name }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
